import { render, staticRenderFns } from "./DashboardFaturamentoVisaoMunicipiosKpisDataTable.vue?vue&type=template&id=a07b6a9c&"
import script from "./DashboardFaturamentoVisaoMunicipiosKpisDataTable.vue?vue&type=script&lang=js&"
export * from "./DashboardFaturamentoVisaoMunicipiosKpisDataTable.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFaturamentoVisaoMunicipiosKpisDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VProgressCircular,VTextField,VTooltip})
